import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { RadioInput } from '@calendly/ui/components/radio-input';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { FullStoryExclude, FullStoryMask } from '../../../../../shared/fullstory_privacy';
const containerDisabledCss = "c1y2i5ey";
const containerCss = "ctppov1";
const Container = forwardRef((props, ref) => {
  const {
    disabled,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerDisabledCss]: disabled
  }, props.className)} />;
});
const textCss = "tnqypz9";
const Text = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textCss, props.className)} />;
});
const descriptionCss = "dp0qdkr";
const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
const addendumCss = "axpemlq";
const Addendum = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(addendumCss, props.className)} />;
});
export const Member = ({
  membership,
  originalUserUUID,
  selectedUserUUID,
  onClick
}) => {
  const title = membership.isPending ? membership.email : membership.name;
  const description = membership.isPending ? I18n.t('publisher.dashboard.pending_invitation') : membership.email;
  const isDisabled = !membership.enabled || membership.isPending;
  const isChecked = !isDisabled && selectedUserUUID === membership.userUuid;
  const showOriginalAssignment = originalUserUUID === membership.userUuid;
  return <Container disabled={isDisabled}>
      <RadioInput spacingRight={12} spacingTop={12} name="member" disabled={isDisabled} checked={isChecked} onClick={onClick} />
      <FullStoryExclude>
        <Avatar src={membership.avatarUrl} letter={membership.avatarLetter} aria-hidden tabIndex={-1} />
      </FullStoryExclude>
      <Text>
        <div>
          <FullStoryMask>{title}</FullStoryMask>
        </div>
        <Description>
          <FullStoryMask>{description}</FullStoryMask>
        </Description>
        {showOriginalAssignment && <Addendum>
              {I18n.t('publisher.dashboard.event.originally_assigned')}
            </Addendum>}
      </Text>
    </Container>;
};

require("./member.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./member.js");